import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { RegionService } from '../../services/region.service';
import { SessionService, ZeissPanel } from '../../services/session.service';
import { NetworkStatusService } from '../../services/network-status.service';
import { SharedConstants } from '../../services/shared/shared-constants';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'slide2-page',
  templateUrl: 'slide2.html',
})
export class Slide2Page {
  onlineStatus: boolean;
  constructor(
    private router: Router,
    public regionService: RegionService,
    public sessionService: SessionService,
    public networkService: NetworkStatusService,
    private trackingService: TrackingService
  ) {
    this.networkService.online$.subscribe((res) => {
      this.onlineStatus = res;
    });
  }

  prev(): void {
    this.onlineStatus ? this.router.navigate(['visual-challenges']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
    this.trackingService.resetTrackingValues();
  }

  next(): void {
    this.onlineStatus ? this.router.navigate(['environment']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
  }

  selectPanel(panel: ZeissPanel): void {
    let panelIndex: number;
    this.sessionService.age.panels.forEach((agePanel: ZeissPanel, index: number) => {
      if (agePanel.html === panel.html) {
        panelIndex = index;
      }
    });

    // allow deselect radios
    if (this.sessionService.age.selected === panelIndex) {
      this.sessionService.age.selected = null;
    } else {
      this.sessionService.age.selected = panelIndex;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/slide2/slide2.ts